// Created by hejikun on 2017/10/25 0025.
let state = {
  isList: 0
}

export default {
  state
}
